import { campusApi, domainApi } from "service/api";
import { LIST, panelApi, runQuery } from "./panelApi";

// Runs a service call that answers { error, message, data } and returns its
// data; an error answer ({ error: true, message }) becomes the query's error
const dataOf = (request) =>
  runQuery(async () => {
    const res = await request();
    if (res?.error) throw new Error(res.message);
    return res.data;
  });

/**
 * One campus / one domain (RTK Query), cached per id: opening it again shows
 * the last data at once while it is refreshed (the pages ask with
 * refetchOnMountOrArgChange).
 */
export const detailEndpoints = panelApi.injectEndpoints({
  endpoints: (build) => ({
    getCampus: build.query({
      queryFn: (campusId) => dataOf(() => campusApi.getById(campusId)),
      providesTags: (result, error, campusId) => [
        { type: LIST.campus, id: campusId },
      ],
    }),
    getDomain: build.query({
      queryFn: (domainId) => dataOf(() => domainApi.getById(domainId)),
      providesTags: (result, error, domainId) => [
        { type: LIST.domain, id: domainId },
      ],
    }),
  }),
});

export const { useGetCampusQuery, useGetDomainQuery } = detailEndpoints;
